import DashboardEmpty from './dashboard-empty.component'

export default DashboardEmpty